// @flow

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.header6,
    marginLeft: '.5rem',
    fontWeight: 600,
    color: theme.colors.pastelGrey,
    '&:hover, &:focus, &:active': {
      color: theme.colors.white,
      opacity: 1
    },
    [theme.breakpoints.gte.mobile.portrait]: {
      ...theme.typography.header5,
      marginLeft: '1.125rem'
    }
  },
  active: {
    color: theme.colors.white
  }
}));

type Props = {
  to: string,
  children: string | React.Element<typeof FormattedMessage>
};

const NavLogo = ({ children, to }: Props) => {
  const classes = useStyles();

  return (
    <NavLink to={to} className={classes.root} activeClassName={classes.active}>
      {children}
    </NavLink>
  );
};
NavLogo.displayName = 'NavLogo';
NavLogo.defaultProps = {
  to: '/'
};

export default NavLogo;
